
export const ACTION_CONTEXT_SERVICE = "ActionContextService";

export interface ActionContextService<ActionContext> {

    /** Get the context for an action */
    getContext(): ActionContext;

}
